export const isRawLabelPrintingEnvironment = () => ['semper', 'agip'].includes(
    window.location.pathname.split('/').filter(Boolean)[0]
);

export const downloadBase64File = (base64Content, fileName, mimeType) => {
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Uint8Array(byteCharacters.length);

    for (let index = 0; index < byteCharacters.length; index += 1) {
        byteNumbers[index] = byteCharacters.charCodeAt(index);
    }

    const blob = new Blob([byteNumbers], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
